import { makeAutoObservable } from 'mobx'
import Feature from 'ol/Feature'
import { Geometry } from 'ol/geom'
import { TreeNode } from '@shared/ui-native/Tree'

export interface Layer {
    uuid: string
    text: string
    demUrl: string
}

export interface Measurement {
    id?: number;
    fillVolume: number;
    cutVolume: number;
    base64Image: string;
    demBase64Image: string;
    modelBase64Glb: string;
    modelName: string;
    baseHeight: number;
    tolerance: number;
    color: object;
    feature: Feature<Geometry>;
    lowestPoint: number;
    highestPoint: number;
}

class LayerStore {
    target: Layer | TreeNode | null = null;
    reference: Layer | TreeNode | null = null;
    layers: Layer[] = [];

    constructor() {
        makeAutoObservable(this);
    }

    setReference(layer: Layer | TreeNode) {
        this.reference = layer;
    }

    setTarget(layer: Layer | TreeNode) {
        this.target = layer;
    }

    setLayers(layers: Layer[]) {
        this.layers = layers;
    }
}

class MeasurementStore {
    measurements: Measurement[] = [];
    selectedMeasurementIndex = null;
    nextId = 1;

    constructor() {
        makeAutoObservable(this);
    }

    addMeasurement(measurement: Omit<Measurement, 'id'>) {
        this.measurements.push({
            id: this.nextId,
            ...measurement
        });
        this.nextId += 1;

        return this.nextId - 1;
    }

    selectMeasurement(index) {
        this.selectedMeasurementIndex = index;
    }

    updateMeasurement(measurement: Measurement) {
        this.measurements[measurement.id - 1] = {
            ...measurement
        }
    }

    deleteMeasurement(id: number) {
        this.measurements = this.measurements.filter(
            measurement => measurement.id !== id
        );
        if (this.selectedMeasurementIndex === id) {
            this.selectedMeasurementIndex = null;
        }
        this.nextId -= 1;
    }

    clearMeasurements() {
        this.measurements = [];
        this.selectedMeasurementIndex = null;
        this.nextId = 1;
    }
}

export const layerStore = new LayerStore();
export const measurementStore = new MeasurementStore();
